<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle" :isShow="isShow" :headText="headText"></titleHead>
    <div class="w80">
      <div class="fsb mb-60">
        <!--左边-->
        <div style="width: 72%">
          <div class="fsl">
            <div class="college_top">
              <img class="top_img" :src="collegeObj.cover" alt="" />
              <user-operation
                v-if="collegeObj.title"
                class="ml-15"
                :shareObj="collegeObj"
                @onCollection="goCollection"
              ></user-operation>
            </div>
            <div class="college_middle">
              <h4>{{ collegeObj.title }}</h4>
              <p class="mt-10">
                <span>课程摘要:</span>
                <span>{{ collegeObj.des }}</span>
              </p>
              <p class="mt-10">
                <span>课程分类：</span>
                <span>{{ cate }}</span>
              </p>
              <div class="college_bater fdc mt-10">
                <p class="">
                  <span class="pl-10">文档价格：</span
                  ><span class="colors">￥{{ collegeObj.price }}</span>
                </p>
                <p class="f1 ml-50">
                  <span>浏览次数：</span><span>{{ collegeObj.viewerscount }}</span>
                </p>
              </div>
              <div class="mt-30">
                <button
                  v-if="isBuy"
                  class="college_btn background1"
                  @click.prevent="onDownnload()"
                >
                  立即下载
                </button>
                <button v-else class="college_btn background2" @click.prevent="goBuy()">
                  我要购买
                </button>
              </div>
            </div>
          </div>

          <div class="mt-30">
            <contTitle :contTitle="contTitle" :obj="obj"></contTitle>
            <div class="mt-20 college_meter">
              <div v-html="collegeObj.content"></div>
              <pdf-loader v-if="readFile" :src="readFile"></pdf-loader>
              <div class="box_coment">
                <button
                  v-if="
                    collegeObj.source &&
                    collegeObj.source.split('.').includes('pdf') &&
                    !isBuy
                  "
                  @click="onBuy"
                >
                  继续阅读
                </button>
              </div>
            </div>
            <!--导师介绍-->
            <!-- <div class="participating_experts wrap">
            <h3 class="tips">参与导师</h3>
            <div class="exports_list">
              <div class="button-prev" @click="swiperChange('prev')">
                <svg
                  t="1603440419638"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2695"
                  width="32"
                  height="32"
                >
                  <path
                    d="M671.807 927.804l-415.632-415.804 415.632-415.803 63.445 63.616-352.017 352.209 352.017 352.102z"
                    p-id="2696"
                    fill="#8a8a8a"
                  ></path>
                </svg>
              </div>
              <div v-swiper:mySwiper="swiperOption">
                <div class="swiper-wrapper">
                  <div
                    class="swiper-slide box"
                    v-for="(item, index) in expertsList"
                    :key="index"
                  >
                    <expert-card :info="item"></expert-card>
                  </div>
                </div>
              </div>
              <div class="button-next" @click="swiperChange('next')">
                <svg
                  t="1603440337801"
                  class=""
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="2017"
                  width="32"
                  height="32"
                >
                  <path
                    d="M325.048 93.511l-60.030 59.435 357.181 359.631-360.184 356.603 59.522 59.93 420.207-416.043z"
                    p-id="2018"
                    fill="#8a8a8a"
                  ></path>
                </svg>
              </div>
            </div>
          </div> -->
          </div>
		 <!--推荐视频-->
          <div>
            <contTitle class="mt-30" :contTitle="contTitle1" :obj="obj"></contTitle>
            <div class="mt-10 fdc pb-20">
              <div
                @click="toCourseDetail(item)"
                class="college_recom"
                v-for="(item, index) in curseList.slice(0, 3)"
                :key="index"
              >
                <div class="college_mater">
                    <img :src="item.cover" />
                    <img class="model" src="@/assets/images/play.png">
                </div>
                <p>{{ item.title }}</p>
              </div>
            </div>
          </div>
        </div>
        <!--右边-->
        <!-- <div class="corpor_bater">
           <div class="corpor_side">
               <h3>推荐视频</h3>
               <span @click.prevent="onChange(2)">换一批</span>
           </div>
           <div class="mt-10">
               <div class="corpor_box" v-for="(info,index) in recommendLesson.slice(0,2)" :key="index">
                    <div class="corpor_cox">
                       <img :src="info.cover" alt="">
                    </div>
                    <p>{{info.title}}</p>
               </div>
           </div>
        </div> -->

        <div style="width: 25%">
          <comentTitle
            :comentTitle="comentTitle"
            :comentText="comentText"
            @onEitd="toMore"
          ></comentTitle>
          <div class="expert mt-20">
            <swiperItem v-if="expertList.length > 0" :list="expertList" @onExpert="goExpert"></swiperItem>
          </div>
        </div>
      </div>

      <!--弹框登录-->
      <loginDialog :dialogVisible.sync="dialogVisible"></loginDialog>
    </div>
  </div>
</template>
<script>
import { collegeInfo } from "@/api/my";
import {
  createorder,
  addCollection,
  vod,
  alreadypurchase,
  iscollection,
  download,
} from "@/api/coment";
import { getLessonList, getExpertList, getCollegeFile } from "@/api/information";
import { getToken } from "@/utils/auth";
import { getRandomArray } from "../../utils/index";
import commBanner from "../../common/commBanner";
import titleHead from "../../common/titleHead";
import contTitle from "../../common/contTitle";
import comentTitle from "../../common/comentTitle";
import swiperItem from "../../common/swiperItem";
import userOperation from "../../common/userOperation";
import newsRecommend from "../../common/newsRecommend";
import expertCard from "../../components/expertCard";
import loginDialog from "../../components/loginDialog";
import pdfLoader from "@/common/pdfLoader";
export default {
  components: {
    commBanner,
    titleHead,
    contTitle,
    comentTitle,
    swiperItem,
    userOperation,
    newsRecommend,
    expertCard,
    loginDialog,
    pdfLoader,
  },
  data() {
    return {
      headTitle: "环学院",
      isShow: true,
      headText: "农村传统炉灶的改造与生物质能源清洁利用",
      contTitle: "课件详情",
      contTitle1: "推荐视频",
      contTitle3: "导师介绍",
      comentTitle: "环保达人",
      comentText: "更多 >",
      sourcetype: null,
      obj: {
        title: "课件详情",
        contCount: "",
        isShow: false,
        roleType: "",
        personalType: 2,
        // content:'公司主营产品及服务包括:金属氧化物避雷器带电检测仪、数字式钳形伏安相位表、大型地网接地电阻测量仪、多通道波形记录仪、PT感应耐压试验电源、高压高稳定电源...',
        // bannerUrl: require("@/assets/images/banner.jpg"),
      },
      collegeObj: {},
      expertList: [], //专家列表
      expertQuery:{
        curPage:1,
        limit:9
      },
      total:0,
      recommendLesson: [], //课程列表
      swiperOption: {
        slidesPerView: 3, // 显示的数量
        spaceBetween: 30, // 每张的间距
        slidesPerGroup: 1,
      },
      id: "",
      active: false,
      curseList: [],
      coursePager: {
        curPage: 1,
        limit: 3,
      },
      isBuy: false,
      cate: "",
      dialogVisible: false,
      readFile: "",
      isYur: true,
    };
  },
  created() {
    let id = this.$route.query.id;
    this.id = id;
    this.getDetail(id);
    this.getExpert();
    this.getCollegeFile();
    if (getToken()) {
      this.getAlreadypurchase();
    }

    this.getLessonList();
    if (this.$store.state.user.userInfo != null) {
      let type = this.$store.state.user.userInfo.type;
      this.obj.roleType = type;
    }
  },
  watch: {
    sourcetype(val, oldval) {
      if (val == 0) {
        this.$router.push({
          path: "/environmental_college_detail",
          query: { id: this.id },
        });
      }
    },
  },
  methods: {
    //课程详情
    getDetail(id) {
      let params = { id: id };
      collegeInfo(params)
        .then((res) => {
          if (res.code == 0) {
            this.collegeObj = res.data;
            this.headText = res.data.title;
            this.sourcetype = res.data.sourcetype;
            this.cate = this.getCate(res.data.category);
          }
        })
        .catch((err) => {});
    },
    getCate(id) {
      return this.$store.getters.itemIndutry(id);
    },
    //获取试读文件
    getCollegeFile() {
      getCollegeFile({ id: this.$route.query.id }).then((res) => {
        if (res.code == 0) {
          this.readFile = res.data;
        }
      });
    },
    goExpert(item){
      this.expertQuery.curPage = item;
      if(this.total == this.expertList.length) return;
      this.getExpert();
    },
    //查询专家列表
    getExpert() {
      getExpertList({
         ...this.expertQuery,
        weight: 0,
      })
        .then((res) => {
          if (res.code == 0) {
            this.total = res.data.totalCount;
            this.expertList = this.expertList.concat(res.data.list);
          }
        })
        .catch((err) => {});
    },

    //切换轮播图
    swiperChange(type) {
      switch (type) {
        case "prev":
          this.mySwiper.slidePrev();
          break;
        default:
          this.mySwiper.slideNext();
          break;
      }
    },
    //更多
    toMore() {
      this.$router.push({
        path: "/expert_list",
      });
    },
    //获取更多
    getLessonList() {
      getLessonList({
        ...this.coursePager,
        recommend: 1,
      }).then((res) => {
        if(res.code == 0){
          this.curseList = res.page.list;
        }
      });
    },

    toCourseDetail(item) {
      this.$router.push({
        path: "/environmental_college_detail",
        query: { id: item.id },
      });
    },
    // //获取推荐课程
    // getRecommendlist() {
    //   getLessonList({
    //     curPage: 1,
    //     limit: 4,
    //     recommend: 1,
    //   }).then((res) => {
    //     this.recommendLesson = res.page.list;
    //   });
    // },
    //换一批
    // onChange(length){
    //   this.recommendLesson  =_.compact(
    //     getRandomArray(_.cloneDeep(this.recommendLesson), length));
    // },

    goBuy() {
      if (getToken() == undefined) {
        this.dialogVisible = !this.dialogVisible;
      } else {
        this.onBuy();
      }
    },
    //购买
    onBuy() {
      let postData = {
        amount: this.collegeObj.price,
        goodsId: this.$route.query.id,
        goodsType: 4,
      };
      createorder(postData)
        .then((res) => {
          if (res.code == 0) {
            localStorage.setItem("list", JSON.stringify(res.data));
            localStorage.setItem("title", this.collegeObj.title);
            localStorage.setItem("sourtype", res.sourtype);
            if (res.data.status == 1) {
              this.$message({
                message: "购买成功!",
                type: "success",
              });
              this.isBuy = true;
              this.isYur = false;
            } else {
              let url = window.location.href;
              let str = url.split("/")[3];
              sessionStorage.setItem("url", str);
              this.$router.push({
                name: "payment_information",
              });
            }
          }
        })
        .catch((err) => {});
    },
    //收藏
    goCollection() {
      let info = this.$store.state.user.userInfo;
      if (info == null) {
        this.$message({
          message: "登录后，才能收藏",
          type: "info",
        });
      } else {
        addCollection({
          goodsId: this.$route.query.id,
          goodsType: 4,
        })
          .then((res) => {
            if (res.code == 0) {
              this.$message({
                message: "收藏成功！",
                type: "success",
                duration: 1000,
              });
            }
          })
          .catch((err) => {});
      }
    },
    //下载
    onDownnload() {
      let params = {
        goodstype: 4,
        goodsid: this.$route.query.id,
      };
      download(params)
        .then((res) => {
          if (res.code == 0) {
            window.open(res.url, "_blank");
            // let url = res.url.split(",");
            // url.forEach((item) => {
            //   const iframe = document.createElement("iframe");
            //   iframe.style.display = "none"; // 防止影响页面
            //   iframe.style.height = 0; // 防止影响页面
            //   iframe.src = item;
            //   document.body.appendChild(iframe); // 这一行必须，iframe挂在到dom树上才会发请求
            //   setTimeout(() => {
            //     iframe.remove();
            //   }, 5 * 60 * 1000);
            // });
          }
        })
        .catch((err) => {});
    },
    //查询资源是否已购买
    getAlreadypurchase() {
      let params = {
        goodstype: 4,
        goodsid: this.$route.query.id,
      };
      alreadypurchase(params)
        .then((res) => {
          if (res.code == 0) {
            if (res.data == true) {
              this.isBuy = true;
            }
          }
        })
        .catch((err) => {});
    },
    keepTextStyle(val) {
      return (val + "").replace(/(<br[^>]*>|\s*)/g, "");
    },
  },
};
</script>
<style scoped lang="less">
.college_recom {
  width: 32%;
}
.college_mater{
  position: relative;
  height: 162px;
}
.college_mater img {
  width: 100%;
  height: 100%;
}
.college_mater img:hover{
  cursor: pointer;
}
.college_mater img.model{
  position: absolute;
  width: 50px;
  height: 50px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}


.college_recom p {
  padding-top: 10px;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  height: 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.f1 {
  flex: 1;
}
.fsb {
  display: flex;
  justify-content: space-between;
}
.fsl {
  display: flex;
  justify-content: left;
}
.colors {
  color: #ff7302;
  font-size: 14px;
}
.mt-10 {
  margin-top: 10px;
}
.mt-20 {
  margin-top: 20px;
}
.ml-15 {
  margin-left: 15px;
}
.ml-30 {
  margin-left: 30px;
}
.ml-50 {
  margin-left: 50px;
}
.mb-60 {
  margin-bottom: 60px;
}
.pl-10 {
  padding-left: 10px;
}
.pb-20 {
  padding-bottom: 20px;
}
.top_img {
  width: 100%;
  height: 386px;
  //   height: 446px;
}
.college_middle {
  padding: 10px 15px;
  width: 50%;
}
.college_middle h4 {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 17px;
}
.college_middle p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
}
.college_bater {
  height: 41px;
  line-height: 41px;
  background: #eeeeee;
}
.college_btn {
  width: 114px;
  height: 35px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  font-size: 12px;

  border-radius: 3px;
}
.background1 {
  background: #f6bc20;
}
.background2 {
  background: #ff7302;
}

.college_meter {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 23px;
}
.college_photo {
  width: 100%;
  height: 346px;
}
.college_shire {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.shire_btn {
  margin-top: 50px;
  width: 114px;
  height: 35px;
  background: #68be31;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.college_recom {
  width: 32%;
}
.college_recom img {
  width: 100%;
  height: 162px;
}
.college_recom p {
  padding-top: 10px;
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.swiper-container {
  width: 100%;
  height: 400px;
  padding: 0 10px;
}
.swiper-wrapper {
  height: 400px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
}
// .swiper-slide {
//   height: 400px;
//   margin-right: 20px;
//   display: flex;
//   overflow: hidden;
//   align-items: center;
// }
.swiper-slide img {
  margin-left: 10px;
  width: 89px;
  height: 89px;
}
.export_desc {
  margin: 0px 10px;
}
.export_desc p:nth-child(1) {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  margin-top: 10px;
}
.export_desc p:nth-child(2) {
  margin-top: 10px;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  /*多行溢出省略*/
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.wrap {
  margin: 0 auto;
}
.participating_experts {
  margin-top: 59px;
  width: 100%;
  h3 {
    margin: 35px 0;
    text-align: center;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
  }
  .exports_list {
    display: flex;
    align-items: center;
    .button-prev,
    .button-next {
      margin-top: 90px;
      cursor: pointer;
    }
  }
}

/***右边 */

.corpor_bater {
  background: #f8f8f8;
  border-top: 2px solid #9ad02a;
  padding-bottom: 20px;
  height: 450px;
  width: 25%;
}
.corpor_side {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 10px;
}
.corpor_side h3 {
  margin-left: 15px;
}
.corpor_side span {
  cursor: pointer;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a;
  margin-right: 20px;
}
.corpor_side span::before {
  display: inline-block;
  content: "";
  width: 17px;
  height: 17px;
  background: url("../../assets/images/update.jpg") no-repeat center/100%;
  vertical-align: top;
  margin-right: 3px;
}
.corpor_box {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 20px 18px;
}
.corpor_box p {
  margin-top: 8px;
  display: -webkit-box;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  white-space: nowrap;
}
.corpor_cox {
  overflow: hidden;
}
.college_top {
  width: 50%;
}
.corpor_cox img {
  width: 100%;
}
</style>
<style>
.el-message-box__btns .el-button {
  width: 80px;
}
.confirmButton {
  margin-left: -80px !important;
  margin-right: 105px !important;
}
.cancelButton {
  margin-right: -100px !important;
}
.cancelButton:hover {
  background-color: #fff;
  color: #333;
  border-color: #dcdfe6;
}

.box_coment {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 46px;
}
.box_coment button {
  width: 114px;
  height: 35px;
  background: #68be31;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/view/coment/curriculumDetail.vue